import { useQuery } from "@tanstack/react-query";
import { QueryKeysEnum } from "../types/QueryKeysEnum";
import { getInstallation } from "../generated-api/account";
import { useAccountClient } from "./useAccountClient";

export const useInstallation = (
  accountId = "",
  installationId = "",
  throwOnError?: boolean | ((error: Error) => boolean),
) => {
  const client = useAccountClient();
  const response = useQuery({
    queryKey: [QueryKeysEnum.Installation, accountId, installationId],
    queryFn: async () => {
      const { data } = await getInstallation({
        client,
        throwOnError: true,
        path: {
          accountId,
          installationId,
        },
      });

      return data;
    },
    throwOnError,
    enabled: Boolean(accountId) && Boolean(installationId),
  });

  return response;
};
